import uuid from 'react-uuid';
import sanitizeFileName from './sanitizeFileName';
import setFileNameExtension from './setFileNameExtension';
export default function prepareFileName(_ref) {
  var name = _ref.meta.name,
      extension = _ref.extension;
  var sanitizedName = sanitizeFileName(name);
  var sanitizedExtension = sanitizeFileName(extension);
  var sanitizedNameWithExtension = setFileNameExtension(sanitizedName, sanitizedExtension);
  var uniqueName = "".concat(uuid(), "_").concat(sanitizedNameWithExtension);
  return {
    displayName: sanitizedNameWithExtension,
    extension: sanitizedExtension,
    uniqueName: uniqueName
  };
}